import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import cls from "../../styles/NavBar.module.css";
import { RiApps2Line } from "react-icons/ri";
import { IoIosArrowUp} from "react-icons/io";

const NavBar = () => {
  const ctx = useContext(AuthContext);

  const logoutHandler = () => {
    ctx.logout();
  };

  const [openNav, setOpenNav] = React.useState(false);

  const openNavHandler = () => {
    setOpenNav(!openNav);
  };
  const closeNavHandler = () => {
    setOpenNav(false);
  };

  return (
    <header className={cls.header}>
      <div className={cls.logo}>
        <h1>Title</h1>
      </div>
      <nav className={cls.nav}>
        {openNav && (
          <>
            {!ctx.isAuthenticated && (
              <>
                <li className={cls.li}>
                  <NavLink to="/" activeClassName={cls.active}>
                    Home
                  </NavLink>
                </li>
                <li className={cls.li}>
                  <NavLink to="/login" activeClassName={cls.active}>
                    Login
                  </NavLink>
                </li>
                <li className={cls.li}>
                  <NavLink to="/signup" activeClassName={cls.active}>
                    Signup
                  </NavLink>
                </li>
              </>
            )}

        {ctx.isAuthenticated && (
          <>
            <li className={cls.li}>
              <NavLink to="/about" activeClassName={cls.active}>
                About
              </NavLink>
            </li>
            <li className={cls.li}>
              <NavLink to="/blog" activeClassName={cls.active}>
                Blog
              </NavLink>
            </li>
            <li className={cls.li}>
              <NavLink to="/createblog" activeClassName={cls.active}>
                Create
              </NavLink>
            </li>
            <li className={cls.li}>
              <a href="/" onClick={logoutHandler}>
                Logout
              </a>
            </li>
          </>
        )}
          </>
        )}

        {/* nav button experimetn */}
        
          <li className={`${cls.li} ${cls.iconLi}`} onClick={openNavHandler}>
            <NavLink to="/" className={cls.iconLink}>
            {openNav ? <IoIosArrowUp className={cls.icons}/>:<RiApps2Line className={cls.icons} />}
            </NavLink>
          </li>
      </nav>
    </header>
  );
};

export default NavBar;
